export const categories = [
  {
    id: 911,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Trending sneakers, boots, sandals and all footwear finds curated from top sellers',
    imageSeq: 'cat-shoes-01',
  },
  {
    id: 912,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies, crewnecks and knitwear for every season and style preference',
    imageSeq: 'cat-hoodies-02',
  },
  {
    id: 913,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Graphic tees, basic essentials and statement pieces from reliable sources',
    imageSeq: 'cat-tshirts-03',
  },
  {
    id: 914,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    description: 'Bombers, denim jackets, puffer coats and outerwear for every occasion',
    imageSeq: 'cat-jackets-04',
  },
  {
    id: 915,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Cargo pants, jeans, tailored trousers and summer shorts from verified shops',
    imageSeq: 'cat-pants-05',
  },
  {
    id: 916,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-graduation-cap-line',
    description: 'Caps, beanies, bucket hats and stylish head accessories to complete any outfit',
    imageSeq: 'cat-headwear-06',
  },
  {
    id: 917,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Coordinated matching sets, tracksuits and outfits ready to wear straight away',
    imageSeq: 'cat-sets-07',
  },
  {
    id: 918,
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-contrast-line',
    description: 'Comfortable basics, boxers, briefs and everyday essentials at competitive prices',
    imageSeq: 'cat-underwear-08',
  },
  {
    id: 919,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-trophy-line',
    description: 'Sports jerseys, team kits and athletic wear from popular leagues and brands',
    imageSeq: 'cat-jersey-09',
  },
  {
    id: 920,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Watches, sunglasses, jewelry and small accessories that elevate any look',
    imageSeq: 'cat-accessories-10',
  },
  {
    id: 921,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    description: 'Backpacks, crossbody bags, totes and luggage from trusted manufacturers',
    imageSeq: 'cat-bags-11',
  },
  {
    id: 922,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    description: 'Leather belts, designer-style buckles and waist accessories for men and women',
    imageSeq: 'cat-belts-12',
  },
  {
    id: 923,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    description: 'Designer-inspired fragrances, colognes and perfumes at fraction of retail prices',
    imageSeq: 'cat-perfumes-13',
  },
  {
    id: 924,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Home goods, gadgets, lifestyle products and miscellaneous discoveries worth checking',
    imageSeq: 'cat-other-14',
  },
];